import styled from 'styled-components';

type CodeEntrySlotsProps = {
  code: string;
  codeLength: number;
  groupBreakAfter?: number;
  digitFontSizePx?: number;
};

const CodeSlotTrack = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: ${({ theme }) => theme.scale.px(11)};
`;

const CodeSlot = styled.span<{
  $digitFontSizePx: number;
  $hasGroupBreak: boolean;
}>`
  width: ${({ theme }) => theme.scale.px(17)};
  min-height: ${({ theme }) => theme.scale.px(26)};
  border-bottom: ${({ theme }) =>
    `${theme.scale.px(2)} solid ${theme.colors.border.codeEntry}`};
  display: grid;
  place-items: end center;
  margin-right: ${({ $hasGroupBreak, theme }) =>
    $hasGroupBreak ? theme.scale.px(12) : '0'};
  font-size: ${({ $digitFontSizePx, theme }) =>
    theme.scale.px($digitFontSizePx)};
  font-weight: 500;
  line-height: 1;
`;

export function CodeEntrySlots({
  code,
  codeLength,
  groupBreakAfter,
  digitFontSizePx = 24,
}: CodeEntrySlotsProps) {
  return (
    <CodeSlotTrack aria-hidden="true">
      {Array.from({ length: codeLength }, (_, index) => (
        <CodeSlot
          $digitFontSizePx={digitFontSizePx}
          $hasGroupBreak={index === groupBreakAfter}
          key={`code-entry-slot-${index + 1}`}
        >
          {code[index] ?? ''}
        </CodeSlot>
      ))}
    </CodeSlotTrack>
  );
}
